<template>
  <div id="edit__project__modal" class="project-modal edit-deliverable-modal edit-project-modal" :class="!userCanEditProject ? 'read-only' : ''">
    <div class="project--top--section">
      <div class="row">
        <div class="col-md-8 d-flex left--side">
          <div class="project--page--title">
            <h2 class="d-inline-block">
              <div class="project-icon bigger-icon pointer-default" :style="{backgroundColor: getProjectColor(projectDetail)}">
                <img src="@/csmworkflow/img/white-folder.svg"/>
              </div>
            </h2>
            <div class="text--section">
              <div class="project--department--wrap">
                <ProjectDepartments :deliverable="projectDetail" />
              </div>
              <label class="mb-0 w-100">
                <h1
                style="line-height: 1;"
                @click="activateTitleField"
                class="mb-0 exclude-outside-click edit-d-title project-title"
                v-show="!editTitle"
                >{{ projectDetail.title || 'Click to set...' }}</h1>
                <textarea
                v-click-outside="outside"
                ref="deliverableTitle"
                v-show="editTitle"
                v-model="projectDetail.title"
                type="text"
                placeholder="Project title..."
                class="form-control mb-3 title-field exclude-outside-click h1"
                @change="updateProjectTitle"
                @blur="editTitle=false;"></textarea>
              </label>
              <div class="project-number"><span>Project Number: {{ projectDetail.project_number }}</span></div>
              <div class="project-due-date">
              	Deadline:
                <span ref="refDatepickerWrapper" class="editable-project-due-date" @click="projectDueDateClick">
                  <div class="custom-field-outside-bg-mobile" v-show="editProjectDueDateBg"></div>
                  <vuejs-datepicker
                    ref="projectDueDate"
                    v-model="projectDetail.due_date"
                    @input="updateProjectDueDate"
                    @focusin.native="findPosition"
                    @selected="projectDueDateSelected"
                    v-field-dismiss="editProjectDatePickerClickOutside"
                    placeholder="No Date"
                  >
                    <div slot="beforeCalendarHeader" class="calender-header">
                      <b-button class="remove-dl-btn" variant="text" @click="resetDeadline">Remove Deadline</b-button>
                      <b-button class="today-btn" variant="text" @click="onToday">Today</b-button>
                    </div>
                  </vuejs-datepicker>
                </span>
              </div>
            </div>
          </div>
          <div v-if="projectDeliverables.length" class="project--milestones">
            <label class="field-label">PROJECT MILESTONES</label>
            <div class="project--milestones-wrap">
              <div v-b-tooltip="{ customClass: 'milestone--tooltip', html: true, title: tipData(projectDeliverables[index-1]), trigger: 'hover' }" :class="{'active': projectDeliverables[index-1].is_complete == 1, 'dots': index <= projectDeliverables.length}" class="milestone" v-for="index in projectDeliverables.length">
                <span class="milestone--full--deliverable">&nbsp;</span>
                <div class="milestone--task--expanson">
                  <span @click="scrollToTask(projectDeliverables[index-1].tasks[index1-1].id, index)" :style="{backgroundColor: tryJSONParse(getFieldJson(projectDeliverables[index-1].tasks[index1-1].taskFields, 'status').value).color}" v-for="index1 in projectDeliverables[index-1].tasks.length"
                  v-b-tooltip="{ customClass: 'milestone--tooltip', html: true, title: tipTaskData(projectDeliverables[index-1].tasks[index1-1]), trigger: 'hover', placement: 'bottom' }">&nbsp;</span>
                </div>
              </div>
            </div>
            <div class="dates">
              <span class="left">{{ projectDetail.start_date | moment("MMMM DD, YYYY") }}</span>
              <span class="right">{{ projectDetail.due_date | moment("MMMM DD, YYYY")  }}</span>
            </div>
          </div>
          <div
          class="field-box project--detail--field"
          v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_detail'})"
          :key="'prj__detail__'+index"
          >
            <ProjectCustomFields :deliverable="projectDetail" :customField="field" />
          </div>
          <div class="project--resources">
            <div class="dropdown project--resources--title">
              <button
                title="Add resource"
                class="add-resource-button exclude-outside-click d-inline-block"
                id="add-resource-button"
                data-toggle="dropdown" aria-expanded="false"
              >Resources</button>
              <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
              <div class="dropdown-menu project--resources--type--menu">
                <a class="dropdown-item" href="#" v-for="(type,i) in optionsForLinkType" :key="i" @click="addResourceMenuItemClick(type, $event)"><img class="link-type-icon" :src="require(`@/csmworkflow/img/${type.icon}`)"> {{type.name}}</a>
              </div>
            </div>




            <div :class="getProjectResourcesClass" >
              <div class="resource-entry resource-box"
                :class="userCanEditProject ? 'editable' : 'not-editable'"
                v-for="(resource, index) in _.filter(projectDetail.customFields, {field_key: 'link_url'})"
                :key="'link_url-'+index"
                v-if="showResourceBox(resource.value,resource.pfv_id)"
              >
              <img class="link-type-icon" :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type',resource.pfv_id)).icon}`)" draggable="false">
                <div class="resource-box__url"></div>
                <a class='resource-link' v-if="resource.value" :href="resource.value" @click="openCopyLinkModal(resource.value, $event, index)" target="_blank" :id="`project-resource-${index}`">{{customChildFieldValue('link_label',resource.pfv_id) || resource.value}}</a>
                <a class="resource-link" v-if="!resource.value" :href="getResourceHref(resource.value, resource.pfv_id)" target="_blank"
                :id="`project-resource-${index}`" @click="setCookieForDownload"
                >{{customChildFieldValue('link_label',resource.pfv_id) || resource.value}}</a>
                <b-tooltip :target="`project-resource-${index}`" noninteractive triggers="manual"><i class="fas fa-check" style="color:'var(--wf-primary)';"></i> Link Copied!</b-tooltip>
                <a
                v-b-tooltip.hover
                title="Edit resource"
                class="edit-resource-btn"
                href="#"
                v-if="userCanEditProject"
                @click.prevent="editResource(resource)"
                >
                  <i class="fas fa-edit"></i>
                </a>

                <div class="resource-box__notes" v-if="customChildFieldValue('link_notes',resource.pfv_id)">{{customChildFieldValue('link_notes',resource.pfv_id)}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 right--side">
          <div class="project-right-side-fields">
            <div
              class="field-box"
              v-if="typeof projectDetail == 'object' && projectDetail.engagement_manager && getSystemSetting('project__show_engagement_manager')"
              >
                <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="{field_key: 'engagement_manager',field_name: 'engagement_manager', label: 'Engagement Manager'}" />
            </div>
            <div
              class="field-box"
              v-if="typeof projectDetail == 'object' && projectDetail.project_lead"
              >
              <ProjectCustomFields 
                :key="`prjfields${projectDetail.id}`" 
                :deliverable="projectDetail" 
                :customField="{ 
                  field_key: 'project_lead', 
                  field_name: 'project_lead', 
                  label: getSystemSetting('project__project_lead_label') || 'PROJECT LEAD' 
                }" 
              />
            </div>
            <div
            class="field-box"
            v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_status'})"
            :key="'prj__budget__'+Math.random()"
            >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <div
            class="field-box"
            v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_audience'})"
            :key="'prj__budget__'+Math.random()"
            >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'project_secondary_audience'})"
              :key="`prj__${field.field_key}__${index}`"
              >
              <ProjectCustomFields 
              :key="'prjfields'+projectDetail.id" 
              :deliverable="projectDetail" 
              :customField="field" />
            </div>
            <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'account_number'})"
              :key="`prj__${field.field_key}__${index}`"
              >
              <ProjectCustomFields 
              :key="'prjfields'+projectDetail.id" 
              :deliverable="projectDetail" 
              :customField="field" />
            </div>
            <div
            class="field-box"
            v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'budget'})"
            :key="'prj__budget__'+Math.random()"
            >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <div
              class="field-box"
              v-if="showProjectCustomField(projectDetail, 'requisition_number')"
              v-for="(field, index) in _.filter(projectDetail.customFields, {field_key: 'requisition_number'})"
              :key="'prj__requisition__number__'+index"
              >
              <ProjectCustomFields :key="'prjfields'+projectDetail.id" :deliverable="projectDetail" :customField="field" />
            </div>
            <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.projectCustomFields, {field_key: 'manager_marketing_branding'})"
              :key="`prj__${field.field_key}__${index}`"
              >
              <ProjectCustomFields
              :key="'prjfields'+projectDetail.id"
              :deliverable="projectDetail"
              :customField="field" />
            </div>
            <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.projectCustomFields, {field_key: 'marketing_officer'})"
              :key="`prj__${field.field_key}__${index}`"
              >
              <ProjectCustomFields 
              :key="'prjfields'+projectDetail.id" 
              :deliverable="projectDetail" 
              :customField="field" />
            </div>
            <div
              class="field-box"
              v-for="(field, index) in _.filter(projectDetail.projectCustomFields, {field_key: 'communications_officer'})"
              :key="`prj__${field.field_key}__${index}`"
              >
              <ProjectCustomFields 
              :key="'prjfields'+projectDetail.id" 
              :deliverable="projectDetail" 
              :customField="field" />
            </div>
            <b-tabs class="field-tabs" content-class="field-tab-content" fill v-model="currentTab" v-if="projectDetail.id">
              <b-tab class="field-tab-contacts field-box" active title="Contact" 
              v-if="hasContactFields()" >
                  <ProjectContact :projectDetail="projectDetail" />
              </b-tab>
              <b-tab class="field-tab-chat" 
              :lazy="lazyLoadChat" 
              title="Chat" 
              v-if="getSystemSetting('is_chat_enabled')" 
              @click="turnOffLazy" >
                <div class="chat-wrapper">
                  <Chat 
                  :primaryParticipantId="projectDetail.id" 
                  :primaryParticipantTitle="projectDetail.title" 
                  :primaryParticipantType="0" 
                  :chatNamespace="'projectChat'"
                  :shouldRefreshMessages="currentTab == 1"
                  />
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div :class="{'open': showModalOptions, 'calendar-controls': $router.currentRoute.name == 'calendar'}" class="responsive-edit-modal-controls">
      <button
      v-b-tooltip.hover
      title="Delete Project"
      @click="removeProject()"
      class="btn delete-deliverable-btn"
      v-if="userCanEditProject"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
      <button
      v-if="$router.currentRoute.name == 'calendar'"
      v-b-tooltip.hover
      title="Close"
      @click="onCloseModal"
      class="btn close-deliverable-btn"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <b-modal v-model="showRemoveProject" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveProject" ok-title="Yes, Delete">
      <p>Are you sure you want to delete this project?</p>
    </b-modal>
    <b-modal centered no-close-on-backdrop hide-footer id="createProjectLinkModal" title="New Resource / Link" @shown="focusLinkModal">
      <CreateProjectLinkModal  ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType"  :is-file="editLinkIsFile"
      :resource-parent="'project'" />
    </b-modal>
    <b-modal centered no-close-on-backdrop hide-footer id="editProjectLinkModal" title="Update Resource / Link" @shown="focusEditLinkModal">
      <EditProjectLinkModal  ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel" v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile" />
    </b-modal>
    <b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
      <LinkCopyLinkModal :linkUrl="linkCopyModalValue" />
  </b-modal>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import Vue from 'vue';
import vueFilePond from "vue-filepond";
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Format from "../../utility/Format";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import ProjectCustomFields from "../common/ProjectCustomField";
import Chat from "./Chat";
import CreateProjectLinkModal from "./CreateProjectLinkModal";
import EditProjectLinkModal from "./EditProjectLinkModal";
import ProjectContact from "./ProjectContact";
import ProjectDepartments from "./ProjectDepartments";

const VueFilePond = vueFilePond();

import "filepond/dist/filepond.min.css";

export default {
  props: ['projectDeliverables'],
  data() {
    return {
      Format,
      currentTab: 0,
      dateSelected: false,
      showModalOptions: false,
      renderCount: 1,
      editTitle: false,
      showRemoveProject: false,
      showRemoveResource:false,
      addResourceFlag:false,
      lazyLoadChat: true,
      linkUrl:null,
      linkLabel:null,
      linkNotes:null,
      linkType:null,
      completedCount: [],
      currentDotPosition: [],
      filepond: [],
      editLinkIsFile: false,
      editProjectDueDateBg: false,
      linkCopyModalValue: "",
      linkCopyLinkTimeouts: {},
    };
  },
  components: {
    'vuejs-datepicker': Datepicker,
    Chat,
    ProjectContact,
    ProjectCustomFields,
    ProjectDepartments,
    Autocomplete,
    EditProjectLinkModal,
    CreateProjectLinkModal,
    VueFilePond,
    LinkCopyLinkModal,
  },
  computed: {
    ...mapGetters([
      "allDepartments",
      "systemSettings",
      "getSystemSetting",
      "userAbilities",
      "projectDetail",
      "allCustomFields"
    ]),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    getProjectResourcesClass() {
    	let className = "project--resources--content field-box__content";
    	let hasResources = false;
    	if (this.projectDetail) {
    		if (this.projectDetail.customFields) {
	    		for (var i=0; i < this.projectDetail.customFields.length; i++ ){
	    			if (this.projectDetail.customFields[i].field_key == 'link_url') {
	    				hasResources = true;
	    			}
	    		}
	    		if (hasResources) {
	    			className += " has-entries";
	    		}
	    	}
    	}
    		return className;
    },
    userCanEditProject() {
			const userId = localStorage.getItem("userId");
      const project = this.projectDetail;

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}

			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
		},
    calculateEndDate() {
      let latestDueDate = null;

      if (this.projectDeliverables && this.projectDeliverables.length > 0) {
        this.projectDeliverables.forEach(deliverable => {
          if (deliverable.tasks && deliverable.tasks.length > 0) {
            deliverable.tasks.forEach(task => {
              const dueDateField = task.taskFields.filter(x => x.field_key == 'due_date')[0];
              let dueDateFieldValue = null;
              if (dueDateField && dueDateField.value) {
                dueDateFieldValue = Vue.moment(dueDateField.value);
              }
              if (dueDateFieldValue && (!latestDueDate || latestDueDate.isBefore(dueDateFieldValue))) {
                latestDueDate = Vue.moment(dueDateFieldValue);
              }
            });
          }
        });
      }

      return latestDueDate;
    },
    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch("fetchAllCustomFields");
      } else {
        return JSON.parse(linkTypeField.value_set);
      }
		},
  },
  methods: {
    ...mapActions([
      "updateFieldValue",
      "updateProjectFieldValue",
      "fetchProjectDeliverable",
      "highlightTask",
      "updateDueDate"
    ]),
    ...mapMutations([
      "setProjectDetail"
    ]),
    hasContactFields() {
      const contactCustomFields = _.filter(this.projectDetail.projectCustomFields, {field_type: 'contacts'});
      if (Array.isArray(contactCustomFields) && contactCustomFields.length) {
        // array exist, is not empty
        return true;
      }
    },
    turnOffLazy() {
      // lazyLoadChat = true when modal is opened, no chat related api calls
      // Chat tab is clicked once, chat api calls, roomInfo and messages are loaded
      // turn off lazy loading to avoid api calls whenever tab is clicked again
      this.lazyLoadChat = false;
    },
    showProjectCustomField(project, fieldKey) {
      const projectCustomFieldArray = this._.filter(project.projectCustomFields, { field_key: fieldKey });
      if (Array.isArray(projectCustomFieldArray) && projectCustomFieldArray.length) {
        // array exist, is not empty
        return true;
      }
      return false;
    },
    projectDueDateClick() {
        if (this.dateSelected){
            this.editProjectDueDateBg = false;
        }else{
            this.editProjectDueDateBg = true;
        }
        this.dateSelected = false;
    },
    projectDueDateSelected(){
        this.editProjectDueDateBg = false;
        this.dateSelected = true;
    },
    findPosition() {
      if (this.$refs.refDatepickerWrapper.getBoundingClientRect().y > 315) {
        $(".editable-project-due-date .vdp-datepicker__calendar").css("top", "-282px");
      } else {
        $(".editable-project-due-date .vdp-datepicker__calendar").css("top", "unset");
      }
    },
    updateProjectDueDate() {
      this.updateDueDate({projectData: this.projectDetail}).then(() => {
      })
    },
    onToday() {
      this.projectDetail.due_date = this.$moment().format("YYYY-MM-DD H:m:s");
      this.$refs.projectDueDate.close();
      this.updateProjectDueDate();
    },
    resetDeadline() {
      this.projectDetail.due_date = null
      this.updateProjectDueDate();
    },
    customDateFormat(date) {
      return this.$moment(date, "YYYY-MM-DD").format("DD MMM, YYYY");
    },
    scrollToDeliverable(deliverableId, dIndex) {
      const id = 'project__deliverable__' + deliverableId;
      const yOffset = -95;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    },
    scrollToTask(taskId, dIndex) {
      const id = "task__title__" + taskId;
      const taskElOffset = $(".task-fields .field-block ." + id).offset();
      this.highlightTask(taskId);
      if (taskElOffset.top == 0) {
        this.$root.$emit('bv::toggle::collapse', "task-listing-collapse-" + (dIndex - 1));
      } else {
        this.$nextTick(() => {
          const taskElOffset2 = $(".task-fields .field-block ." + id).offset();
          window.scrollTo({top: taskElOffset2.top - 195, behavior: 'smooth'});
        });
      }
    },
    getFieldJson(fieldArray, fieldKey) {
      let field
      field = _.filter(fieldArray, {field_key: fieldKey})
      if(field) {
        return field[0]
      }
    },
    tipTaskData(taskData) {
      let taskTitle = taskData.title
      let taskStatusJson = this.getFieldJson(taskData.taskFields, 'status')
      let taskStatus = this.tryJSONParse(taskStatusJson.value)
      return taskStatus.name + ' : ' + taskTitle
    },
    tipData(deliverableData) {
      return deliverableData.due_date ? Vue.moment(deliverableData.due_date).format("MMMM DD, YYYY") : Vue.moment(deliverableData.created_at).format("MMMM DD, YYYY") + '<br>'+deliverableData.title
    },
    updateProjectTitle() {
      this.projectDetail.title = Format.replaceLineBreaks(this.projectDetail.title, " ");
      this.updateProjectFieldValue(this.projectDetail).then(() => {
        this.fetchProjectDeliverable(1);
      });
    },
    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
      this.editTitle = false;
    },
    showAddResource() {
      this.addResourceFlag = true;
    },
    clearFlags() {
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    getResourceHref(url, parent_id) {
      let label = this.customChildFieldValue('link_label', parent_id);
      let fileId = this.customChildFieldValue('file_id', parent_id);
      if (url == null && fileId != null && label) {
        return `${this.apiUrl}downloadFileProject/${this.projectDetail.id}/${fileId}`;
      }
      return "";
    },
    openCopyLinkModal(link, e, i) {
      if (!link.includes("\\")) {
        return;
      }
      e.preventDefault();
      this.copyLink(link, i);
    },
    async copyLink(link, resourceId) {
      clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
      Object.keys(this._.filter(this.projectDetail.customFields, {field_key: 'link_url'})).forEach(x => {
        if (x == resourceId) return;
        this.$root.$emit('bv::hide::tooltip', 'project-resource-' + x);
      })

      const navPer = await navigator.permissions.query({name: "clipboard-write"});
      if (navPer.state == "granted" || navPer.state == "prompt") {
          try {
              await navigator.clipboard.writeText(link);
          } catch {
              console.error("clipboard API error. Cannot copy to clipboard.");
              this.legacyCopyMethod(link);
          }
      } else {
        this.legacyCopyMethod(link);
      }

      this.$root.$emit('bv::show::tooltip', 'project-resource-' + resourceId);
      this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', 'project-resource-' + resourceId);
      }, 2000);
    },
    legacyCopyMethod(link) {
      let tempInput = document.createElement("input");
      tempInput.style = "position: absolute; left: -1000px; top: -1000px; z-index: -9999";
      tempInput.value = link;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },

    showResourceBox(url, parent_id) {
      let fileId = this.customChildFieldValue('file_id',parent_id);
      return (url != null || fileId != null);
    },
    customChildField(key, parent_id) {
        if (this.projectDetail.customFields) {
          let obj = _.filter(this.projectDetail.customFields, {field_key: key, parent_id:parent_id});
          if (obj.length > 0) {
            // lets add it to the
            return obj;
          } else {
            if (key == 'file_id') return null;
            if (key == 'link_type') return [];
            // return the global version of the custom field...
            let field = _.filter(this.allCustomFields, {field_key: key});
            obj = {};
            obj.id = null;
            obj.parent_id = this.projectDetail.customFields[index].id;
            obj.project_id = this.projectDetail.customFields[index].project_id;
            obj.editing = false;
            obj.field_id = field[0].id;
            obj.field_key = field[0].field_key;
            obj.field_parent_id = field[0].parent_id;
            obj.field_type = field[0].field_type;
            obj.note = field[0].note;
            obj.value = null;
            obj.label = field[0].label;
            obj.value_set = field[0].value_set;
            obj.updated_at = this.projectDetail.customFields ? this.projectDetail.customFields[index].updated_at : null;
            return [obj];
          }
      }
      return [];
    },
    customChildFieldValue(key, parent_id) {
      if (this.projectDetail.customFields) {
        let obj = _.filter(this.projectDetail.customFields, {field_key: key, parent_id:parent_id});
        if (obj.length > 0) {
          return obj[0].value;
        } else {
          return null;
        }
      }
      return null;
    },
    editResource(resource) {
      this.linkUrl = resource;
      let label =  this.customChildField('link_label', resource.pfv_id);
      if (label.length > 0) {
        this.linkLabel = label[0];
      } else {
        this.linkLabel = {};
      }
      let notes =  this.customChildField('link_notes', resource.pfv_id);
      if (notes.length > 0) {
        this.linkNotes = notes[0];
      } else {
        this.linkNotes = {};
      }
      let type = this.customChildField('link_type', resource.pfv_id);
      if (type.length > 0) {
        this.linkType = type[0];
      } else {
        this.linkType = {
          id:null,
          field_id:37,
          project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_type'})[0]?.projectFieldId,
          parent_field_id:20,
          field_key:"link_type",
          field_type:"select",
          parent_id:null,
          project_id:this.projectDetail.projectId,
          value:1
        };
      }
      let fileId = this.customChildField('file_id', resource.pfv_id);
      this.editLinkIsFile = Boolean(fileId);
      this.$bvModal.show("editProjectLinkModal");
    },
    addResource(typeId = 1, modalId) {
      // if(!this.userAbilities.editMediaCall || this.projectDetail.permissions.viewOnly) return;
      if (!this.userCanEditProject) return;
      this.linkUrl = {
        id:null,
        field_id:20,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_url'})[0].projectFieldId,
        parent_field_id:null,
        field_key:"link_url",
        field_type:"text",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:null
      };
      this.linkLabel = {
        id:null,
        field_id:21,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_label'})[0].projectFieldId,
        parent_field_id:20,
        field_key:"link_label",
        field_type:"text",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:null
      };
      this.linkNotes = {
        id:null,
        field_id:22,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_notes'})[0].projectFieldId,
        parent_field_id:20,
        field_key:"link_notes",
        field_type:"text",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:null
      };
      this.linkType = {
        id:null,
        field_id:37,
        project_field_id:_.filter(this.projectDetail.customFields, {field_key: 'link_type'})[0]?.projectFieldId,
        parent_field_id:20,
        field_key:"link_type",
        field_type:"select",
        parent_id:null,
        project_id:this.projectDetail.projectId,
        value:typeId
      }
      this.$bvModal.show(modalId);
    },
    addResourceMenuItemClick(type, e) {
      e.preventDefault();
      let modalId = "createProjectLinkModal";
      if (type.slug == "file") {
        this.editLinkIsFile = true;
      } else {
        this.editLinkIsFile = false;
      }
      this.addResource(type.id, modalId);
    },
    removeProject() {
      this.showRemoveProject = true;
    },
    onConfirmRemoveProject() {
      if (this.projectDetail.id) {
        let that = this;
        let projectId = this.projectDetail.id;
        this.$store.dispatch("removeProject", { projectId: projectId }).then(function() {
          that.$store.dispatch('manageUndoActivation', 'Project removed.');
          that.$router.push('/project');
        });
      }
    },
    focusLinkModal() {
      this.$refs.refLinkModal.focusMyElement();
    },
    focusEditLinkModal() {
      this.$refs.refEditLinkModal.focusMyElement();
    },
    onCloseModal() {
        this.$bvModal.hide("editProjectModal");
        if(this.$router.currentRoute.name == 'calendar') {
          this.$root.$emit('re__fetch__calendar__data', this.deliverableDetail);
        }
    },
    activateTitleField() {
      if (!this.userCanEditProject) return;
      let that = this
      this.editTitle=true;
      setTimeout(function() {
        that.$refs.deliverableTitle.select();
      }, 100)
    },

    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },



    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },

    editProjectDueDateClick() {
      if (!this.editProjectDueDateBg) {
        this.editProjectDueDateBg = true;
      }
    },
    editProjectDatePickerClickOutside() {
      this.editProjectDueDateBg = false;
    },
  },
  mounted() {
    $('#editProjectModal .modal-content').removeAttr('tabindex');
    let that = this;
    this.$nextTick(function () {
      setTimeout(function () {
        if (that.projectDetail.id !== undefined) {
          // call api to read all alerts after 10 seconds
          that.$store.dispatch(
            'makeAllRelatedAlertRead',
            {
              groupedModelId: that.projectDetail.id
            }
          );
        }
      }, 10000);
    });
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.project--detail--field {
  margin-top: 50px;
}
.editable-project-due-date {
  .vdp-datepicker {
    display: inline-block;
    .day__month_btn,
    .cell,
    .month__year_btn,
    .vdp-datepicker__calendar header {
      color: var(--db-span-hover-black);
    }
    input {
      background: transparent;
      color: var(--db-date-picker);
      font-size: 22px;
      border: unset;
      cursor: pointer;
      &::placeholder {
        color: var(--db-date-picker);
        font-size: 22px;
        opacity: 1;
      }
      &:-ms-input-placeholder {
        color: var(--db-date-picker);
        font-size: 22px;
      }
      &::-ms-input-placeholder {
        color: var(--db-date-picker);
        font-size: 22px;
      }
    }
  }
}

.edit-deliverable-modal .nav-tabs .nav-item .nav-link.active {
  border: unset;
  background: linear-gradient(to bottom, var(--wf-secondary) 0%, var(--edit-deliverable-modal-edit-project-modal-field-header-lgbg) 86%, var(--db-collapse-control-lgbg) 100%);
  border-top-right-radius: 10px;
}

</style>
